import { useParams } from "react-router-dom";
import MeetingRoom from "../components/MeetingRoom/MeetingRoom";
import {
    JitsiTokenResponse,
    useFetchJitsiToken,
} from "../hooks/meeting.queries";
import { useFetchUserDetails } from "../../../hooks/queries/user";
import ListState from "../../../components/ListState/ListState";
import { displayNameInRightFormat } from "../../../utils/helpers";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { handleChangePractice } from "../../../redux/features/practice/practiceSlice";

export default function MeetingRoomPage() {
    const { sessionHistoryId } = useParams();
    const dispatch = useAppDispatch();
    const currentPractice = useAppSelector(
        (state) => state.userPractice.practice
    );
    const loggedInUser = useFetchUserDetails();
    const handleTokenSuccess = (response: JitsiTokenResponse) => {
        const targetPractice = loggedInUser.data?.practices.find(
            (practice) => practice.practice_id === response.data.practice_id
        );
        if (
            !targetPractice ||
            currentPractice?.practice_id === targetPractice.practice_id
        ) {
            return;
        }

        dispatch(
            handleChangePractice({
                practice: {
                    ...targetPractice,
                    user_id: loggedInUser.data?.user_id ?? "",
                },
                updateLocation: false,
            })
        );
    };
    const { isLoading, isFetching, error, isSuccess, data } =
        useFetchJitsiToken(sessionHistoryId ?? "", handleTokenSuccess);
    const isMeetingLoading = isLoading || isFetching;

    return (
        <>
            {isMeetingLoading ? (
                <div
                    className="flex items-center justify-center h-[92vh]"
                    data-testid="loader"
                >
                    <span className="mid-loader" />
                </div>
            ) : null}
            {!isMeetingLoading && error ? (
                <div className="h-full text-sm font-medium flex items-center justify-center">
                    <ListState
                        isError
                        errorMsg={
                            error?.response?.data?.message ||
                            "Could not load meeting at this time"
                        }
                        stateHelperText="Plese contact support for assistance"
                        context="general"
                        cardClass="h-[92vh]"
                    />
                </div>
            ) : null}
            {!isMeetingLoading && isSuccess ? (
                <MeetingRoom
                    jitsiToken={data.data.token}
                    sessionHistoryId={sessionHistoryId ?? ""}
                    email={loggedInUser?.data?.user_email ?? ""}
                    providerName={
                        loggedInUser?.data
                            ? displayNameInRightFormat({
                                  firstName: loggedInUser.data.first_name,
                                  lastName: loggedInUser.data.last_name,
                              })
                            : ""
                    }
                    userId={loggedInUser?.data?.user_id ?? ""}
                />
            ) : null}
        </>
    );
}
